import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination } from 'swiper/modules';

class ImageSliderCarousel extends HTMLElement {
  connectedCallback() {
    this.captionElement = this.querySelector('[data-current-caption]');
    this.initSwiper();
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    const paginationEl = this.querySelector('.swiper-pagination');
    const showNavigation = this.querySelector('.next-button') !== null;
    if (!swiperContainer) return;

    const modules = [Keyboard, Pagination];
    if (showNavigation) modules.push(Navigation);

    const swiper = new Swiper(swiperContainer, {
      modules,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      width: swiperContainer.offsetWidth,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el: paginationEl,
        type: 'fraction',
        formatFractionCurrent: (number) => number,
        formatFractionTotal: (number) => number,
      },
      navigation: showNavigation
        ? {
            nextEl: '.next-button',
            prevEl: '.prev-button',
          }
        : false,
      on: {
        init: () => swiperContainer.classList.remove('swiper-loading'),
        slideChange: (swiper) => {
          this.updateCaption(swiper);
          this.handleVideoPlayback(swiper);
        },
      },
    });

    this.swiper = swiper;
  }

  updateCaption(swiper) {
    this.captionElement.innerHTML = swiper.slides[swiper.activeIndex].getAttribute('data-caption');
  }

  handleVideoPlayback(swiper) {
    const allVideos = this.querySelectorAll('video');
    allVideos.forEach((video) => {
      video.pause();
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlide.querySelector('video');

    if (activeVideo && activeSlide.getAttribute('data-media-type') === 'video' && activeVideo.muted)
      activeVideo.play();
  }
}

customElements.define('image-slider-carousel', ImageSliderCarousel);
